import { type ReactElement } from 'react';

import { NetworkDiagram } from '../components/network-diagram';
import { useProjectStore } from '../store/project-store';

/** 唯讀任務相依網路；選取沿用全 App 的 task selection model。 */
export function NetworkDiagramView(): ReactElement {
  const project = useProjectStore((state) => state.project);
  const selectedTaskIds = useProjectStore((state) => state.selectedTaskIds);
  const selectTasks = useProjectStore((state) => state.selectTasks);
  const setActiveView = useProjectStore((state) => state.setActiveView);

  return (
    <section data-testid="network-diagram-view" className="flex h-full min-h-0 flex-col gap-2">
      <header className="flex flex-wrap items-center gap-2 text-xs">
        <p className="text-slate-500 dark:text-slate-400">
          箭頭表示任務相依；紅色節點表示要徑任務。
        </p>
        <button
          type="button"
          disabled={selectedTaskIds.length !== 1}
          onClick={() => setActiveView('gantt')}
          className="ml-auto rounded border border-slate-300 px-2 py-1 hover:bg-slate-100 disabled:cursor-not-allowed disabled:opacity-50 dark:border-slate-600 dark:hover:bg-slate-800"
        >
          在甘特圖中查看
        </button>
      </header>
      <div className="min-h-0 flex-1 overflow-hidden rounded border border-slate-200 bg-white dark:border-slate-700 dark:bg-slate-900">
        <NetworkDiagram
          project={project}
          selectedTaskIds={selectedTaskIds}
          onSelectTask={(taskId) => selectTasks([taskId])}
        />
      </div>
    </section>
  );
}
